import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {AppState} from '../../../../store/appState';
import {makeGetApiToken} from '../../../../store/data/apiTokens/apiTokensSelectors';
import {SettingsDevelopersHeaderTokenAction} from './settingsDevelopersHeaderTokenAction';

/*
 * Props.
 */

interface SettingsDevelopersHeaderTokenActionContainerProps {
  tokenId: number;
}

/*
 * Selectors.
 */

function getTokenId(_state: AppState, props: SettingsDevelopersHeaderTokenActionContainerProps) {
  return props.tokenId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SettingsDevelopersHeaderTokenActionContainerProps>()(() => ({
  token: makeGetApiToken(getTokenId),
}));

export const SettingsDevelopersHeaderTokenActionContainer = connect(mapStateToProps)(
  SettingsDevelopersHeaderTokenAction,
);
